import React, { useState, useEffect } from 'react';
import axios from 'axios';
import axiosIntance from '../../helper/axios'
import { useHistory } from "react-router-dom";
import ReactDOM from 'react-dom';
import MaterialTable from "material-table";
import Sidebar from '../Template/Sidebar/Sidebar';
import Header from '../Template/Header/Header';
import {baseUrl} from '../../config';

import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

import {clickColor,inArray} from './../../library/util';
import Loader from "react-loader-spinner";
function Gateways() {

  const history = useHistory();
  const [selectedRow, setSelectedRow] = useState(null);
  const [loader,setLoader]=useState(false)
  checkUserTypeFn(history);

  const [selectedrowList,setSelectedRowList]=useState([]);


 const setRowBackground = (selectedRow)=>{
        if(inArray(selectedRow.tableData.id,selectedrowList)==false){ 
        setSelectedRowList(oldArray => [...oldArray,selectedRow.tableData.id] );
        setSelectedRow(selectedRow.tableData.id)
        console.log(selectedrowList)
        }else{    
          setSelectedRow(500000)
          setSelectedRowList([])
        }
      }
      

function checkUserTypeFn(history){
  const userdata=JSON.parse(localStorage.getItem('userdata'));
  const usertype=userdata.type;
  console.log('in check usertype fn');
  console.log(usertype)
  if(usertype!='admin' && usertype!='superadmin' && usertype!='subadmin' && usertype!='databasehelper' && usertype!='owneradmin'){
    history.push('/');
 }

}
  const handleSignOut = () => {
    window.localStorage.setItem('isLogin',false);
    history.push('/');
  }

  if(localStorage.getItem('isLogin')==="false" || localStorage.getItem('isLogin')==null){
    history.push('/');
  }

  const [midData,setMidData]=useState([])
  
  const [message, setMessage] = useState('')
  const data = [['attribute', 'attribute2'], ['value1', 'value2']];
  const [successMsg,setSuccessMsg]=useState('')
  useEffect(() => {
    setLoader(true)
    axiosIntance.get(baseUrl+'/gateways', {}).then(response => {

      console.log(response.data.result)
      console.log(response.data.result.length)
      if (response.data.result.length > 0) {
        console.log('data we have')
        setMidData(response.data.result);
        console.log(response.data.result)
        setLoader(false)

      } else {
        //setMessage('No data');
        console.log(45)
       // history.push('/home');
      }

    }).catch(error => {
      setMessage('Something went wrong');
    });


    return () => {
      console.log('un subscribe')
    }



  }, [])
 

  const SubmitDelete = (e) => {

    confirmAlert({
      title: '',
      message: 'Are you sure want to delete All data',
      buttons: [
        {
          label: 'Yes',
          onClick: () => 
          axiosIntance.delete(baseUrl+'/gateways', {}).then(response => {
            setSuccessMsg('Deleted!')
            //setTimeout(()=>window.location.href = '/viewMidBaselines',2000)
          }).catch(error => {
            setMessage('Something went wrong');
          })

        },
        {
          label: 'No',
          onClick: () => console.log('No')
        }
      ]
    });
  }
 
  return (

    <div id="wrapper" className>
      <Sidebar />
      <Header handleSignOut={handleSignOut} />

    <div className='delete-div'>
      {
        midData.length>0 ? <button type="button"  onClick={SubmitDelete} className="btn btn-primary">Delete All </button>:''
       
      }
     
    </div>
    <div className='errorMsg'>{message}</div>
    <div className='successMsg viewScreen'>{successMsg}</div>




  


      <section id="content-wrapper">

      {loader &&
    <div className='loaderDiv'>  
        <Loader
              type="Circles"
              color="#b4d6fa"
              height={100}
              width={100}
              //timeout={1000} //3 secs
          />
    </div> 
    }
        <MaterialTable
        // onRowClick={((evt, selectedRow) => setSelectedRow(selectedRow.tableData.id))}
        onRowClick={((evt, selectedRow) => 
          setRowBackground(selectedRow)
          )}

          columns={[
            { title: "Gateway.ID", field: "gateway_id" },
            { title: "Gateway.Alias", field: "gateway_alias" },
            { title: "Bank", field: "bank" },
            { title: "Signer", field: "signer" },
            { title: "Decline.Percent", field: "decline_percent" },
           
            
         
            { title: "Credit.Qual", field: "credit_qual" },
            { title: "Mid.Qual", field: "mid_qual" },
            { title: "Non.Qual", field: "non_qual" },
            { title: "Monthly.Fee", field: "monthly_fee" },
            { title: "Batch.Fee", field: "batch_fee" },
            { title: "Trx.Fee", field: "trx_fee" },
            { title: "CB.Fee", field: "cb_fee" },
            { title: "Refund.Fee", field: "refund_fee" },
            { title: "Reserve.Percent", field: "reserve_percent" },
            { title: "Effective.Gateway.Date", field: "effective_gateway_date" },
            { title: "Past.Reserve.Percent", field: "past_reserve_percent" },
            { title: "Past.Reserve.Date", field: "past_reserve_date" },
            { title: "MDR.Percent", field: "mdr_percent" },
            { title: "Reserve.Capacity", field: "reserve_capacity" },

            
          ]}
          data={
            midData
          }
          options={{
            maxBodyHeight: '500px',
            headerStyle: { position: 'sticky', top: 0,fontSize:'17px',fontWeight:'bold' },
            rowStyle: rowData => ({
              backgroundColor: (selectedRow === rowData.tableData.id) ? clickColor : ''
            })
          }}
          title="Gateways Data"
        />
      </section>
    </div>
    // <section className="bg-back">

    // </section>
  )
}

export default Gateways